module.exports = __webpack_public_path__ + "img/diagram_19_1.6aa76dc8.png";